var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchCaret = function SvgSearchCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.913 4.483 6.191 8.362a.303.303 0 0 1-.417 0L2.087 4.483C1.9 4.305 2.033 4 2.295 4h7.41c.262 0 .394.305.208.483Z",
    fill: "currentColor"
  })));
};
export default SvgSearchCaret;